import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { WdHeroSection } from "../components/website-dev/WdHeroSection";
import { WdCmsSection } from "../components/website-dev/WdCmsSection";
import { WdStaticSection } from "../components/website-dev/WdStaticSection";
import { WdWordPressSection } from "../components/website-dev/WdWordPressSection";
import { WdEcommerceSection } from "../components/website-dev/WdEcommerceSection";
// import { WdPortfolioSection } from "../components/website-dev/WdPortfolioSection";
import "../styles/website-development.css";

export const WebsiteDevelopmentPage = () => {
    const navigate = useNavigate();

    return (
        <div className="wd-product-page">
            <WdHeroSection />
            <div id="wd-cms">
                <WdCmsSection />
            </div>
            <WdStaticSection />
            <WdWordPressSection />
            <WdEcommerceSection />
            {/* Our Work section — temporarily hidden
            <WdPortfolioSection />
            */}

            <section className="wd-section wd-cta">
                <div className="wd-container">
                    <div className="wd-cta__inner">
                        <h2 className="wd-cta__title">
                            Ready to build your next website?
                        </h2>
                        <p className="wd-cta__desc">
                            Tell us your goals — we&apos;ll recommend the right approach and
                            deliver a premium, performance-first experience.
                        </p>
                        <Button
                            className="wd-btn wd-btn--primary wd-btn--lg"
                            onClick={() => navigate("/contact")}
                        >
                            Get a Free Consultation <ArrowRightOutlined />
                        </Button>
                    </div>
                </div>
            </section>
        </div>
    );
};
